import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import { Store } from '@ngrx/store';

import {AccountService} from '../../../services/account.service';
import {Statistics} from '../../../model/statistics.interface';
import {Subscription} from 'rxjs/Subscription';
import {SHIPMENT_HISTORY_LOAD} from '../../../store/actions';
import {ShipmentHistoryState} from '../../../store/reducers';
import {Subject} from "rxjs/Subject";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public statistics: Statistics;
  public shipmentHistory: any;
  public filterParameter: string;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private store: Store<any>
  ) {}

  ngOnInit() {
    this.store.select('shipmentHistory')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
      (data: ShipmentHistoryState) => {
        this.shipmentHistory = data.filter ? data.filteredData : data.initialData;
        this.filterParameter = data.filter;
      });

    this.route.data.subscribe(data => this.statistics = data.statistics);

    this.accountService.getShipmentHistories().subscribe(
      data => this.store.dispatch({
          type: SHIPMENT_HISTORY_LOAD,
          payload: data.data,
        }));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard/dashboard.component.ts